export default __webpack_public_path__ + "e0156d37f4da1cbe4b6d9a458dc402f7.svg";